import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ADMIN_MENU_ITEMS } from '@core/constants/menu.constant';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.html',
  styleUrl: './admin-header.scss',
})
export class AdminHeader implements OnInit {
  private readonly router = inject(Router);

  protected pageTitle = 'Dashboard';
  protected breadcrumbs: string[] = [];

  ngOnInit(): void {
    this.updateFromUrl(this.router.url);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.updateFromUrl((event as NavigationEnd).urlAfterRedirects);
      });
  }

  private updateFromUrl(url: string): void {
    const segments = url
      .replace(/^\/bo\/?/, '')
      .split('/')
      .filter(Boolean);

    this.breadcrumbs = segments.map((segment) => this.formatSegment(segment));

    const activeRoute = segments[0] || 'dashboard';
    const menuItem = ADMIN_MENU_ITEMS.find((item) => item.route === activeRoute);
    this.pageTitle = menuItem?.label || this.formatSegment(activeRoute);
  }

  private formatSegment(segment: string): string {
    return segment
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
